import React, { Component } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions';
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { SendEmailComponent } from '../Shared/SendEmailComponent'
const position = { of: '#historydiv' };

export class VehicleLoanAccountLedgerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenModal: false,
            isEmailSubmitted: false,
            isSubmited: false,
            loadPanelVisible: false,

            chkVehicleSelection: "1",
            dropdownVehicle: [],
            vehicleId: 0,

            errors: {
                vehicleId: '',
            }
        }
        this.getVehicle = this.getVehicle.bind(this);
        this.handleVehicleChange = this.handleVehicleChange.bind(this);
        this.handleVehicleSelectionChange = this.handleVehicleSelectionChange.bind(this);

        this.downloadAccountPaymentTypeSummaryAsPdf = this.downloadAccountPaymentTypeSummaryAsPdf.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }


    showModal = async () => {
        try {
            this.setState({ isOpenModal: true });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getLocation();
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {

        this.setState({ isOpenModal: false });
        await this.handleClearSearch();
    }

    async getVehicle() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('vehicle-api/dropdown/0/0', requestParams);
            const data = await response.json();
            this.setState({
                dropdownVehicle: data.vehiclesDropdown,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleVehicleChange(selectedOption) {
        try {
            let errors = this.state.errors;
            errors.vehicleId = '';
            let vehicleId = 0;
            if (selectedOption !== null && selectedOption.selectedItem !== null) {
                vehicleId = selectedOption.selectedItem.id === null ? 0 : selectedOption.selectedItem.id;
            }
            this.setState({ vehicleId: vehicleId, errors: errors });
        } catch (ex) {
            console.log(ex);
        }
    }

    handleVehicleSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkVehicleSelection: value, vehicleId: 0 });
        this.state.errors["vehicleId"] = "";
    }

  
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isEmailSubmitted: false,
            loadPanelVisible: false,

            chkVehicleSelection: "1",
            vehicleId: 0,
            errors: {
                vehicleId: '',
            }
        });
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.vehicleId = "";

        if (this.state.chkVehicleSelection === "2" && this.state.vehicleId == 0) {
            formIsValid = false;
            errors.vehicleId = "Please select location.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    async downloadAccountPaymentTypeSummaryAsPdf() {
        try {
            this.setState({
                isSubmited: true,
            });
            var RptHead = "";

            var request = new Object();
            request.LocationId = Number(sessionStorage.getItem("session_locationId"));

            if (this.state.chkVehicleSelection === "1") {
                RptHead = " For all Vehicles, ";
                request.vehicleId = 0;
            } else {
                let customer = this.state.dropdownVehicle.find(opt => opt.id == this.state.vehicleId);
                request.vehicleId = parseInt(this.state.vehicleId);
                RptHead = "  " + "For Vehicle " + "  " + customer.name + ",";
            }

            request.Header = RptHead;
            request.MethodName = "GetVehicleLoanAccountLedger";
            request.fileFormat = 'pdf';
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('crystal-report-api', requestParams);
            const dataResponse = await response.json();
            this.setState({
                isSubmited: false,
            });

            let a = document.createElement('a');
            a.href = dataResponse.reportBase64String;
            a.download = 'VehicleLoanAccountLedger.pdf';

            a.click();
        } catch (e) {
            this.setState({
                isSubmited: false,
            });
            console.log(e)
        }
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                var RptHead = "";

                var request = new Object();
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));

                if (this.state.chkVehicleSelection === "1") {
                    RptHead = " For all Vehicles, ";
                    request.vehicleId = 0;
                } else {
                    let customer = this.state.dropdownVehicle.find(opt => opt.id == this.state.vehicleId);
                    request.vehicleId = parseInt(this.state.vehicleId);
                    RptHead = "  " + "For Vehicle " + "  " + customer.name + ",";
                }

                request.Header = RptHead;
                request.MethodName = "GetVehicleLoanAccountLedger";
                request.fileFormat = 'pdf';
                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Vehicle Loan A/C Ledger';
                    let attachments = [];
                    let file = new Object();
                    file.fileData = fileData;
                    file.fileName = 'VehicleLoanAccountLedger.pdf'
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '30%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit}
                        style={(this.state.isSubmited || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Vehicle Loan A/C Ledger</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="allVehicles" value="1" checked={this.state.chkVehicleSelection === "1"} onChange={this.handleVehicleSelectionChange} />
                                            <label className="form-check-label">All Vehicles</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="singleVehicle" value="2" checked={this.state.chkVehicleSelection === "2"} onChange={this.handleVehicleSelectionChange} />
                                            <label className="form-check-label">Single Vehicle</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownVehicle}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select Vehicle"
                                            name="ddvehicle"
                                            defaultValue={0}
                                            value={this.state.vehicleId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleVehicleChange}
                                            showClearButton={true}
                                            disabled={(this.state.chkVehicleSelection === '1')}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["vehicleId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["vehicleId"]}</span>}
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="button" className="btn btn-success btn-sm" title="Download" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Download"><i className="fas fa-file-download"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}